import {theme} from '@chakra-ui/core';

const customTheme = {
	...theme,
	fonts: {
		body: "sans-serif",
		heading: "sans-serif",
	},
	colors: {
		...theme.colors,
		"brand-primary": "#ffe538",
		"brand-grey": "#333",
		blue: {
			...theme.colors.blue,
			500: '#157fa9',
			600: '#075f88',
			700: '#054461',
		},
	},
};

export default customTheme;
